import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextHighlight from '../docket/TextHighlight';


class HistoryEntriesTableBody extends Component {
  constructor(props) {
    super(props);
    this.domElemRef = React.createRef();
  }

  render() {
    return (
      <tbody className="history-entries-table" ref={this.domElemRef}>
        <TextHighlight searchKeywords={this.props.keywords} getParentNode={() => this.domElemRef}>
          { this.props.rows }
        </TextHighlight>
      </tbody>
    );
  }
}

HistoryEntriesTableBody.defaultProps = {
  keywords: '',
};

HistoryEntriesTableBody.propTypes = {
  rows: PropTypes.node.isRequired,
  keywords: PropTypes.string,
};

export default HistoryEntriesTableBody;



// WEBPACK FOOTER //
// ./src/components/case/history/HistoryEntriesTableBody.jsx